import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../stylesheets/Home.css';
import { UserConsumer } from '../context/ThemeContext';
import { SettingContext } from '../context/SettingContext';

class Home extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            terminals: localStorage.terminals ? JSON.parse(localStorage.getItem('terminals')) : '',
            selectedTerminal: localStorage.frequentTerminal ? localStorage.getItem('frequentTerminal') : ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRoute = this.handleRoute.bind(this);
        this.noOfTerminals = JSON.parse(localStorage.getItem('terminals')).length;
    }

    handleChange(event) {
        this.setState({ selectedTerminal: event.target.value });
    }

    handleRoute(routeTo) {
        localStorage.setItem('frequentTerminal', this.state.selectedTerminal === '' ? this.state.terminals[0] : this.state.selectedTerminal);
        this.props.history.push({ pathname: '/' + routeTo, state: { selectedTerminal: this.state.selectedTerminal === '' ? this.state.terminals[0] : this.state.selectedTerminal } });
    }

    render() {
        return (
            <SettingContext.Consumer>{(settingContext) => (
                <UserConsumer>
                    {props => {
                        const { translatedContent } = settingContext;
                        return (
                            <>
                                <Row className="mt-5">
                                    <Col md={{ span: 6, offset: 3 }}>
                                        <Card className="text-center">
                                            <Card.Body>
                                                <Row>
                                                    <Col md="12" lg="6">
                                                        <label htmlFor="selectTerminal"><Card.Title className={!props.isMobile ? 'selectTerminal-margin' : null}><h5>{this.noOfTerminals === 1 ? translatedContent.SingleTerminal : translatedContent.SelectTerminal}</h5></Card.Title></label>
                                                    </Col>
                                                    <Col md="12" lg="6">
                                                        {
                                                            this.noOfTerminals === 1 ?
                                                                <div className="custom-select no-backG" id="selectTerminal">{this.state.terminals[0]}</div>
                                                                :
                                                                <select className="custom-select" value={this.state.selectedTerminal} id="selectTerminal" selected={this.state.selectedTerminal} onChange={this.handleChange}>
                                                                    {
                                                                        this.state.terminals !== '' ?
                                                                            this.state.terminals.map((list, key) => {
                                                                                return <option key={key} value={list}>{list}</option>;
                                                                            })
                                                                            :
                                                                            ''
                                                                    }
                                                                </select>
                                                        }
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col md={{ span: 4, offset: 4 }}>
                                        <div className="text-center">
                                            <Button variant="primary" id="TransactionButton" size="lg" block onClick={() => this.handleRoute('transaction')}>
                                                {translatedContent.Transaction}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col md={{ span: 4, offset: 4 }}>
                                        <div className="text-center">
                                            <Button variant="primary" id="AdministrationButton" size="lg" onClick={() => this.handleRoute('admin')} block>
                                                {translatedContent.Administration}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        );
                    }}
                </UserConsumer>)}
            </SettingContext.Consumer>
        );
    }
}

export default Home;